import { createFrontendModule } from '@backstage/frontend-plugin-api';
import orgPlugin from '@backstage/plugin-org/alpha';

import { NsUserProfileCard } from './ns-user-profile-card';

export type { RoleField, RoleFieldKey } from './entra-role-fields';
export { extractRoleFields } from './entra-role-fields';

/**
 * Override the org `entity-card:org/user-profile` extension so the user detail
 * page renders {@link NsUserProfileCard} instead of the framework card. The NS
 * card keeps the framework avatar/name/email/groups and adds the person's
 * Functie and Afdeling from the `entra.ns.nl/*` annotations.
 *
 * The override re-invokes the original blueprint factory with the same
 * `type: 'info'` / `filter: { kind: 'user' }` params so the card stays in the
 * user info column; only the loader is swapped for the NS component.
 */
export function createUserProfileCardOverride() {
  const override = orgPlugin
    .getExtension('entity-card:org/user-profile')
    .override({
      factory(originalFactory) {
        return originalFactory({
          params: {
            filter: { kind: 'user' },
            loader: async () => <NsUserProfileCard />,
            type: 'info',
          },
        });
      },
    });

  return createFrontendModule({
    extensions: [override],
    pluginId: 'org',
  });
}
